'use client';

import { AnimatePresence } from 'framer-motion';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

interface AnimationProvidersProps {
  children: ReactNode;
}

export function AnimationProviders({ children }: AnimationProvidersProps) {
  const pathname = usePathname();

  return (
    <AnimatePresence
      mode='wait'
      initial={false}
      onExitComplete={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }}
    >
      <div key={pathname} className='w-full'>
        {children}
      </div>
    </AnimatePresence>
  );
}
